import React, { useRef } from "react";
import PropTypes from "prop-types";
import SFCard, { SFCardHeader, SFCardBody } from "./";
import { SFGridContainer, SFGridItem, SFStack } from "../grid";
import SFTypography from "../typography";

import getStyled from "../../hooks/getStyled";
import SFHaloIconWrapper from "../icons/halo";
import SFIconButton from "../button/iconButton";
import { SFDownloadIcon } from "../icons";

const { styled } = getStyled();

const SFCardHeaderStyled = styled(SFCardHeader)(({ theme }) => ({
  borderBottom: "none !important",
  minHeight: 120,
  alignItems: "flex-start",
  backgroundColor: theme.palette.white.main,
  // Download button
  "& .MuiGrid-item:nth-of-type(3)": {
    display: "none",
  },
  // Trend Icon
  "& .MuiGrid-item:nth-of-type(2)": {
    display: "block",
  },
  "&:hover": {
    backgroundColor: theme.palette.grey200.main,
    // Download button
    "& .MuiGrid-item:nth-of-type(3)": {
      display: "block",
    },
    // Trend Icon
    "& .MuiGrid-item:nth-of-type(2)": {
      display: "none",
    },
  },
}));

const SFCardBodyStyled = styled(SFCardBody)(() => ({
  padding: 0,
  display: "flex",
  flex: 1,
  alignItems: "flex-end",
}));

const SFCardStyled = styled(SFCard)(() => ({
  height: "100%",
}));

const ExportContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

const SFIconButtonStyled = styled(SFIconButton)(() => ({
  padding: 0,
  backgroundColor: "transparent !important",
}));

const SFSkillsBreakdownCard = ({
  header,
  subHeaders,
  icon,
  handleDownload,
  children,
}) => {
  const exportRef = useRef(null);

  const downloadHandler = () => {
    handleDownload(exportRef);
  };

  const Header = () => {
    return (
      <SFGridContainer>
        <SFGridItem xs>
          <SFStack direction="column" spacing={0.5}>
            <SFTypography variant="cardTitle">{header}</SFTypography>
            {subHeaders.map((x, index) => (
              <SFTypography variant="body2" key={index}>
                <SFTypography variant="bold">
                  {x.count + " "}
                </SFTypography>
                {x.text}
              </SFTypography>
            ))}
          </SFStack>
        </SFGridItem>
        <SFGridItem xs="auto">
          {icon && (
            <SFHaloIconWrapper size="small" variant="grey" ignoreIcon>
              {icon}
            </SFHaloIconWrapper>
          )}
        </SFGridItem>
        <SFGridItem xs="auto">
          <SFIconButtonStyled variant="secondary" onClick={downloadHandler}>
            <SFDownloadIcon color="black" size="medium" />
          </SFIconButtonStyled>
        </SFGridItem>
      </SFGridContainer>
    );
  };

  return (
    <SFCardStyled>
      <ExportContainer ref={exportRef}>
        <SFCardHeaderStyled subTitle={<Header />} />
        <SFCardBodyStyled>{children}</SFCardBodyStyled>
      </ExportContainer>
    </SFCardStyled>
  );
};

SFSkillsBreakdownCard.propTypes = {
  header: PropTypes.string.isRequired,
  subHeaders: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  icon: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
};

export default SFSkillsBreakdownCard;
